import { AbstractControl, AsyncValidatorFn } from "@angular/forms";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GeNameValidationCriteriaModel, GeNameValidationService } from "../../../../shared/services/ge-name-validation.service";

@Injectable()
export class GeNameValidator {
  constructor(private geNameValidationService: GeNameValidationService) {}


  validateGeName(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<any> => {
      if (!control.value) {
        return null;
      }

      let criteria: GeNameValidationCriteriaModel = {
        geName: control.value
      };

      return this.geNameValidationService.validateGeName(criteria).map(r => {
        if (!r.valid) {
          return {
            invalidGeName: {
              isError: true,
              geName: r.geName
            }
          };
        } else {
          return null; // gotta return null or the control will remain invalid
        }
      });
    };
  }
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/experiment-design/pollination-instructions/validators/ge-name.validator.ts